import LikeSuccessIcon from "./components/elements/icon/LikeSuccess";
import { Button } from "./components/elements";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Uwp, { UploadFileStatusEnum } from "./utils/uwp";
import Log from "./utils/log";
import { elementAction, feedbackAction } from "./store";
import { AppClient } from "./utils/tool/client";
import { Trans, withTranslation } from "react-i18next";
import { PrivacyNotificationDialog, SubmitDialog } from "./components/dialog";
import LikeForm from "./components/LikeForm";
import RadioButton from "./components/elements/RadioButton";
import TitleIcon from "./components/elements/TitleIcon";
import DislikeForm from "./components/DislikeForm";

export default function Page({ t, i18n }) {
  const theme = useSelector((state) => state.element.theme);

  async function confirm() {
    await Uwp.clearWebContent();
    Uwp.redirectToSettingsPage();
    window.location.href = "/ac-feedback-hub";
  }

  return (
    <div
      className={`w-full flex flex-col justify-center items-center min-h-screen text-${theme}-normal text-[16px] pt-4 pb-2 p-4`}
    >
      <LikeSuccessIcon />
      <p className="text-center">{t("like_confirm_message")}</p>
      <div className="pt-7">
        <Button
          className={"h-[32px] w-[132px] text-[16px]"}
          id="contact_asus"
          theme={theme}
          onClick={confirm}
          isFocus={(name) => false}
          isEnabled={true}
        >
          {t("confirm")}
        </Button>
      </div>
    </div>
  );
}
